import BaseApi from "../../../services/baseApi";

class Reporting {

    getPage() {
        return BaseApi({requiresAtuh: true})({
            method: 'POST',
            url: '/private/dailyAccountReport/list',
            headers: {'Content-Type': 'application/json'},
        })
    }
    getById(id) {
        return BaseApi({requiresAtuh: true})({
            method: 'POST',
            url: '/private/dailyAccountReport/view/?id='+id,
            headers: {'Content-Type': 'application/json'},
        })
    }

    search(buildingId,inp,dateFrom,dateTo){
        let formData=new FormData();
        formData.set("buildingId",buildingId)
        formData.set("inp",inp)
        formData.set("from",dateFrom)
        formData.set("to",dateTo)
        return BaseApi({requiresAtuh: true})({
            method: 'POST',
            data:formData,
            url: '/private/dailyAccountReport/search',
            headers: {'Content-Type': 'application/json'},
        })

     }



}
export default new Reporting();
